import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { ColumnsModel } from '../../../../core/models/table/list-layout-models/columns.model';
import { ColumnTypeEnum } from '../../../../core/enums/list-layout/column-type-enum';
import { TableConfigurationModel } from '../../../../core/models/table/table-configuration.model';
import { ActionIdEnum } from 'src/app/core/enums/list-layout/action-id-enum';
import { RowActionsModel } from 'src/app/core/models/table/row-actions.model';
import { AiApiService } from 'src/app/core/services/ai-api.service';
import { CustomDateDisplayEnum } from 'src/app/core/enums/list-layout/custom-date-display-enum';
import { NgSelectListModel } from 'src/app/core/models/ng-select-list.model';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { ListFilterModel } from 'src/app/core/models/table/list-filter.model';

export enum isVisibleEnum {
  DoesNotExist = 0,
  Visible = 1,
  NotVisible = 2,
}


@Component({
  selector: 'app-list-adjustment-modal',
  templateUrl: './list-adjustment-modal.component.html',
  styleUrls: ['./list-adjustment-modal.component.scss'],
})
export class ListAdjustmentModalComponent implements OnInit {

  colors = [
    { value: "green", label: "btn-success" },
    { value: "red", label: "btn-warning" },
    { value: "blue", label: "btn-primary" },
    { value: "teal", label: "btn-info" },
    { value: "purple", label: "btn-secondary" },
    { value: "soft-green", label: "btn-soft-success" },
    { value: "soft-red", label: "btn-soft-warning" },
    { value: "soft-blue", label: "btn-soft-primary" },
    { value: "soft-teal", label: "btn-soft-info" },
    { value: "soft-purple", label: "btn-soft-secondary" },
  ]

  @Input() public tableConfig: TableConfigurationModel = new TableConfigurationModel;
  @Input() public defaultTableConfig: TableConfigurationModel | undefined = undefined;

  modalEdited: boolean = false;
  submitted: boolean = false;
  newTableConfig: TableConfigurationModel = new TableConfigurationModel();
  enumColumnType = ColumnTypeEnum;
  enumCustomDateDisplay = CustomDateDisplayEnum;
  pageSizeFilterDropdownOptions: NgSelectListModel[] = [];
  customDateDisplayOptions = [
    { value: CustomDateDisplayEnum.YMD_Slashes, selectedText: `yyyy/mm/dd` },
    { value: CustomDateDisplayEnum.DMY_Slashes, selectedText: `dd/mm/yyyy` },
    { value: CustomDateDisplayEnum.MDY_Slashes, selectedText: `mm/dd/yy` },
    { value: CustomDateDisplayEnum.YMD_Dashes, selectedText: `yyyy-mm-dd` },
    { value: CustomDateDisplayEnum.DMY_Dashes, selectedText: `dd-mm-yyyy` },
    { value: CustomDateDisplayEnum.MDY_Dashes, selectedText: `mm-dd-yy` },
  ]

  customActions: RowActionsModel[] = [
    {
      visible: 'true',
      label: 'Edit Inline',
      actionId: ActionIdEnum.EnableDisable,
      icon: 'ri-edit-box-line',
      inDropdown: true,
      inList: true,
      visibleOnValues: [false],
      dataFieldName: 'enableInLineEditing'
    },
    {
      visible: 'true',
      label: 'Approve Edits',
      actionId: ActionIdEnum.ApproveEdits,
      icon: 'ri-checkbox-circle-line',
      inDropdown: true,
      inList: true,
      visibleOnValues: [true],
      dataFieldName: 'enableInLineEditing'
    },
    {
      visible: 'true',
      label: 'Delete',
      actionId: ActionIdEnum.Delete,
      icon: 'ri-close-circle-line',
      inDropdown: true,
      inList: true,
      visibleOnValues: [true],
      visibilityByColumnType: ColumnTypeEnum.CustomUserInputFromConfig,
      dataFieldName: 'enableInLineEditing'
    }
  ]

  constructor(
    private modalRef: NgbActiveModal,
    private authMyFileService: AuthMyfileService,
    private aiApiService: AiApiService
  ) { }

  ngOnInit(): void {
    this.loadAdjustableComponent();
  }

  onRowActionClicked(action: ActionIdEnum | undefined, data: ColumnsModel) {

    if (action == ActionIdEnum.EnableDisable) {
      data.isBeingInlineEdited = true;
    }
    if (action == ActionIdEnum.ApproveEdits) {
      data.isBeingInlineEdited = false;
    }
    if (action == ActionIdEnum.Delete) {
      Swal.fire({
        title: $localize`:@@:Delete Column`,
        text: $localize`:@@:Are you sure you want to delete the column?`,
        icon: 'warning',
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        showCancelButton: true,
        confirmButtonColor: 'rgb(3, 142, 220)',
        cancelButtonColor: 'rgb(243, 78, 78)',
        confirmButtonText: $localize`:@@:Yes, delete the column`,
        cancelButtonText: $localize`:@@:No, keep the column`
      }).then(result => {
        if (result && result.isConfirmed) {
          this.newTableConfig.columns.splice(data.order, 1);
          this.newTableConfig.columns.forEach((column, index) => {
            column.order = index;
          })
          data.isBeingInlineEdited = false;
        }
      });
    }

  }

  showAction(data: ColumnsModel, actionModel: RowActionsModel): boolean {

    var visibilityOfAction: boolean = true;

    visibilityOfAction = actionModel.visibleOnValues!.includes(data.isBeingInlineEdited);

    if(actionModel.visibilityByColumnType != undefined){
        if(data.type != actionModel.visibilityByColumnType){
          visibilityOfAction = false;
        }
    }

    return visibilityOfAction;
  }

  customColorIcon(actionColor: String | undefined) {
    if (actionColor !== undefined) {
      return actionColor;
    }

    return `text-muted`;
  }

  inputFieldEnabled(index: number | undefined): boolean {
    //the returns seemed reversed since [disabled] is disabled when true is returned. 
    if (this.tableConfig.activeInputFieldIndex !== undefined && this.tableConfig.activeInputFieldIndex === index) {
      return false;
    } else {
      return true;
    }
  }

  getIfVisibleStatus(isVisibleValue: boolean | string | undefined): boolean {
    if (typeof (isVisibleValue) == 'boolean') {
      return isVisibleValue;
    } else if (isVisibleValue === undefined) {
      return true;
    } else if (typeof (isVisibleValue) == 'string') {
      if (isVisibleValue === 'true') {
        return true;
      } else if (isVisibleValue === 'false') {
        return false;
      } else {
        return this.authMyFileService.canAccessOperation(isVisibleValue);
      }
    } else {
      return false;
    }
  }

  invertStringBoolean(columnIsVisible: string | undefined) {
    if (columnIsVisible === 'true') {
      return 'false'
    } else if (columnIsVisible === 'false') {
      return 'true'
    } else {
      return columnIsVisible; //default to returning what was the original option if its not a true or false value and is instead an operation.
    }

  }

  close() {
    if (this.modalEdited) {
      this.confirmExit();
    } else {
      this.modalRef.close();
    }
  }

  stopPropagationOnClick($event: MouseEvent) {
    $event.stopPropagation();
  }

  confirmExit() {
    Swal.fire({
      title: $localize`:@@SWAL_UnsavedChanges:You have unsaved changes!`,
      text: $localize`:@@:Are you sure you want to abandon this invite?`,
      icon: 'warning',
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@SWAL_Yes_Discard:Yes, discard changes`,
      cancelButtonText: $localize`:@@:No, let me send it`
    }).then(result => {
      if (result && result.isConfirmed) {
        this.modalRef.close();
      }
    });
  }

  drop(event: { currentIndex: number, previousIndex: number }) {

    var movedElement = this.newTableConfig.columns.splice(event.previousIndex, 1);

    this.newTableConfig.columns = [...this.newTableConfig.columns.slice(0, event.currentIndex), movedElement[0], ...this.newTableConfig.columns.slice(event.currentIndex)];

    this.newTableConfig.columns.forEach((value, i) => {
      value.order = i;
    })

    this.newTableConfig.columns = this.newTableConfig.columns.sort((a, b) => a.order - b.order);
  }


  addColumn() {
    var newColumn = new ColumnsModel();

    newColumn = {
      dataFieldName: '',
      title: '',
      visible: 'true',
      order: this.newTableConfig.columns.length,
      width: "175px",
      type: ColumnTypeEnum.CustomUserInputFromConfig,
      isBeingInlineEdited: true
    }

    this.newTableConfig.columns.push(newColumn);
  }

  updateBool(boolValue: boolean): boolean {
    return !Boolean(boolValue);
  }

  checkForDefaultValues() {
    if (this.tableConfig.filters && this.tableConfig.filters.length > 0) {
      this.tableConfig.filters.forEach((filterModel: ListFilterModel, index) => {
        if (filterModel.removeAllDataReturnPlaceHolder != undefined && filterModel.removeAllDataReturnPlaceHolder == true) {
          this.tableConfig.filters![index] = {
            label: undefined,
            options: [new NgSelectListModel(undefined, undefined, undefined, undefined, true)],
            selectedOption: undefined,
            inDropdown: false,
            inHeading: false,
            inButton: false,
          }

        }
      })
    }
  }

  resetToDefaultList() {
    Swal.fire({
      title: $localize`:@@:Reset List To Default Layout`,
      html: $localize`:@@: Once you press confirm the list layout will be returned to its default state, undoing all changes made to it.`,
      icon: 'warning',
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@:Reset`,
      cancelButtonText: $localize`:@@:Cancel`,
    }).then(result => {
      if (result && result.isConfirmed) {
        this.tableConfig = this.defaultTableConfig!;
        this.loadAdjustableComponent();
      }
    })

  }

  loadAdjustableComponent() {
    //deep copy elements that are needed on the modal, and do not deep copy any elements that have the authSerivce variable. 
    this.newTableConfig.columns = JSON.parse(JSON.stringify(this.tableConfig.columns));

    if (this.tableConfig.customizedListTitle && this.tableConfig.customizedListTitle.length > 0) {
      this.newTableConfig.listTitle = JSON.parse(JSON.stringify(this.tableConfig.customizedListTitle));
    } else {
      this.newTableConfig.listTitle = JSON.parse(JSON.stringify(this.tableConfig.listTitle));
    }

    this.newTableConfig.pageSize = JSON.parse(JSON.stringify(this.tableConfig.pageSize));
    this.newTableConfig.pageSizeFilter = JSON.parse(JSON.stringify(this.tableConfig.pageSizeFilter));

    this.pageSizeFilterDropdownOptions = [];
    this.newTableConfig.pageSizeFilter!.forEach((pageOption: { pageSize: number }) => {
      this.pageSizeFilterDropdownOptions.push(new NgSelectListModel(pageOption.pageSize, `${pageOption.pageSize}`))
    })

    var columnOrder: ColumnsModel[] = [];

    this.newTableConfig.columns.forEach((column) => {
      if (column.order == columnOrder.length) {
        if (column.type != ColumnTypeEnum.Action) {
          column.isBeingInlineEdited = false;
        }
        columnOrder.push(column);
      }
    })

    this.newTableConfig.columns = columnOrder;
  }

  onUpdate() {

    this.tableConfig.columns = this.newTableConfig.columns;
    this.tableConfig.pageSize = this.newTableConfig.pageSize;
    this.tableConfig.pageSizeFilter = this.newTableConfig.pageSizeFilter;
    this.tableConfig.listTitle = this.newTableConfig.listTitle;

    if (this.tableConfig.dateFilter !== undefined) {
      this.tableConfig.dateFilter = { dateRange: undefined }; // need this to not be saving any specific date ranges
    }

    if (this.tableConfig.id) {
      this.checkForDefaultValues();
      this.aiApiService.updateTableConfig(this.tableConfig).subscribe(result => {
        //saved
      });
    } else if (this.tableConfig.canConfigBeSavedToServer == true) {
      this.checkForDefaultValues();
      this.aiApiService.createNewTableConfig(this.tableConfig).subscribe(result => {
        //created
      });
    }

    this.close();
  }
}

